import * as React from "react"

import {
    Div,
    Header,
} from "@bdfx/fukit"
import Section from "../homepage/section"

const Conditions = () => {
    document.title = "GDPR | Pricing Audit"
return (<Section>
<div>
    <Div padding="20px 50px" minHeight={"30vh"}>
        <Header type={1}>Informace o zpracování osobních údajů</Header>
        <p>
            <ul>
                <li>Aktuální znění podmínek zpracování osobních údajů naleznete na <a target="_blank" href={`/pricing/gdpr.pdf`}>tomto odkazu [PDF]</a></li>
            </ul>
        </p>

    </Div>
</div>
</Section>)
}

export default Conditions